import { render, staticRenderFns } from "./NodePoolsPage.vue?vue&type=template&id=f39580a6&scoped=true&"
import script from "./NodePoolsPage.vue?vue&type=script&lang=js&"
export * from "./NodePoolsPage.vue?vue&type=script&lang=js&"
import style0 from "./NodePoolsPage.vue?vue&type=style&index=0&id=f39580a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39580a6",
  null
  
)

export default component.exports